import API from "serviceshift-ui/api-client";

// Mute specific error messages as flash
const mutedErrorMessages = [
  "Email Address Is Already Taken",
  "not_covered_error"
];

const responseInterceptor = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      // Skip redirect for login form requests
      if (error.config.headers.skipRedirectOn401) {
        return Promise.reject(error);
      }
      // Slight delay so UI has a chance to
      // display error message before redirect
      setTimeout(() => {
        window.location.href = window.location.origin;
      }, 500);
      return Promise.reject(error);
    }
    if (
      error.response.data?.includes &&
      error.response.data?.includes("Can't verify CSRF token")
    ) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
      window.notify.error("An unexpected error occurred, please try again.");
      return Promise.reject(error);
    }
    if (
      !mutedErrorMessages.includes(error.response.data.message) &&
      !error.config.headers.ignoreError
    ) {
      window.notify.error(
        error.response.data.message ||
          "An unexpected error occurred, please try again."
      );
    }
  }
  return Promise.reject(error);
};

const requestInterceptor = (config) => {
  if (config.headers["acceptHTML"]) return config;

  const isFormData = config.data instanceof FormData;

  if (!isFormData) {
    config.headers["Accept"] = "application/json";
    config.headers["Content-Type"] = "application/json";
  }

  return config;
};

API.ejectResponseInterceptor();
API.attachResponseInterceptor(responseInterceptor);
API.ejectRequestInterceptor();
API.attachRequestInterceptor(requestInterceptor);
